import React from "react";
import Base from "../core/Base";

export default function UserDashBoard() {
  return (
    <Base title="User Dashboard" description="This is a user dashboard page">
      <h1 className="text-white text-center">Welcome User!!!</h1>
    </Base>
  );
}
